import { Banner } from "@/entities/banner";
import { FaqSection } from "@/entities/faq";
import { FeedbackSlider, feedbackMock } from "@/entities/feedback";
import { PricingPlans } from "@/entities/pricing";
import { FeedbackForm } from "@/features/feedbackForm/ui/FeedbackForm";
import { Section } from "@/shared/ui/section";
import { Advantages, advantagesMock } from "@/widgets/advantages";
import { Call, callMock } from "@/widgets/call";
import { Footer } from "@/widgets/footer";
import { Header } from "@/widgets/header";
import { Productivity, productivityMock } from "@/widgets/productivity";
import { Cases, casesMock } from "@/widgets/сases";
import { Cta, ctaMock } from "@/widgets/сta";

/**
 * Index page
 * @returns {ReactNode}
 * @constructor
 */
export const Index = () => {
  return (
    <>
      <Header />
      <main className={"pageLayout__main bg-[var(--color-bege)]"}>
        <Banner />
        <Section utilClasses={[ "bg-[var(--color-white)]" ]}>
          <Advantages {...advantagesMock} />
          <Cta {...ctaMock} />
          <Cases {...casesMock} />
        </Section>
        <Section utilClasses={[ "feedback", "bg-codGray !pb-0 !z-5" ]} withGradientTop={{ enabled: true }}>
          <FeedbackSlider {...feedbackMock} />
          <Productivity {...productivityMock} />
          <PricingPlans />
        </Section>
        <Section utilClasses={[ "bg-[var(--color-bege)] !z-1" ]} withGradientBottom={{ enabled: true }}>
          <FaqSection />
          <Call {...callMock} />
          <FeedbackForm />
        </Section>
      </main>
      <Footer />
    </>
  );
};
